import { render, staticRenderFns } from "./DemoRequests.vue?vue&type=template&id=8ea0b42e&scoped=true&"
import script from "./DemoRequests.vue?vue&type=script&setup=true&lang=js&"
export * from "./DemoRequests.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ea0b42e",
  null
  
)

export default component.exports